import _ from "lodash";

const initialState = {
  total: "",
  data: [],
  alert: false,
  filterUnread: false,
  isLoading: false
};

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case "RECEIVE_NOTIFICATIONS":
      return Object.assign({}, state, {
        data: action.notifications,
        total: action.total
      });
    case "READ_NOTIFICATION":
      let notification = _.filter(state.data, { id: action.id });
      let replacedfIndex = _.findIndex(state.data, function(lookupItem) {
        return lookupItem.id == action.id;
      });

      if (notification.length === 0) {
        return state;
      } else {
        notification[0].dateOpen = new Date().toDateString();

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, replacedfIndex),
            notification[0],
            ...state.data.slice(replacedfIndex + 1)
          ]
        });
      }
    case "RESET_NOTIFICATIONS":
      return Object.assign({}, state, {
        total: "",
        data: []
      });
    case "ALERT_NOTIFICATIONS":
      return Object.assign({}, state, {
        alert: action.value
      });
    case "SET_FILTER_UNREAD":
      return Object.assign({}, state, {
        filterUnread: action.value
      });
    case "SET_NOTIFICATION_LOADING":
      return Object.assign({}, state, {
        isLoading: action.value
      });
    default:
      return state;
  }
};

export default notifications;



// WEBPACK FOOTER //
// ./src/reducers/notifications.js